// @flow
import React from 'react'
import {setCombatantValue} from '../../../redux-actions/battle-actions.js'
import {handleAnimationEnd, timeout} from './animation-lifecycle-utilities'
import audioManager from '../../../_audio/audio-manager.js'

class AnimationForEach extends React.Component {

  props: {
    casterId: string,
    targetIds: Array<string>,
    targetsDamageTracker: Object
  };

  /** Make the caster wiggle (called once per iteration) */
  async runIterationAnimation(subject:Object, callback:Function) {

    //Play SFX per iteration!
    audioManager.playSfx("sfx_loopIterate");

    //Shake the caster
    setCombatantValue(this.props.casterId, {
      animationCssRule: "tada 0.4s infinite"
    });

    /* ----------- */ await timeout(400);

    //Stop shaking caster
    setCombatantValue(this.props.casterId, {
      animationCssRule: "none"
    });

    /* ----------- */ await timeout(90);

    callback();

  }



  //recursive! Run this step, then call self again with the next step
  runStep(index:number, series:Array<Object>) {
    if (series[index]) {

      return this.runIterationAnimation(series[index], () => {
        this.runStep(index+1, series);
      });

    } else {
      //We've gotten through all of the steps of `series` array. Now fire the "final done" call!
      //console.log("we're done! yaaaaay");
      handleAnimationEnd();
    }
  }

  componentDidMount() {

    //This animation has 1 single target. Find him in the damageTracks (even though this is the only person in the object for this particular Attack)
    const forEachSteps = this.props.targetsDamageTracker[
      this.props.targetIds[0] //Use the first target
    ];

    this.runStep(0, forEachSteps);
  }


  render() {
    return null;
  }
}

export default AnimationForEach;


// WEBPACK FOOTER //
// ./src/battle/ArenaView/animation-components/AnimationForEach.js